/** Performs linear interpolation between `start` and `end` based on `t`. */
export function lerp(start: number, end: number, t: number): number {
  return start + (end - start) * t;
}

/**
 * Smoothly nudge the `current` value to the `target` value based on the
 * `decayRate`. If `clampDistance` is provided, the value will be clamped to the
 * target value when the difference is less than `clampDistance`.
 */
export function smoothNudge(
  current: number,
  target: number,
  decayRate: number,
  delta: number,
  clampDistance?: number,
): number {
  const next = lerp(current, target, 1.0 - Math.exp(-decayRate * delta));

  if (clampDistance != null && Math.abs(next - target) < clampDistance) {
    return target;
  }

  return next;
}
